<script>
  export default{
    props: ["mask", "placeholder", "value", "attr"],
    computed: {
      _value: {
        get: function() {
          return this.value;
        },
        set: function(newValue) {
          this.$emit('input', newValue.replace(/\D/g,""));
        }
      }
    },
    methods: {
      callBusinessRuleFocus: function() {
        if (this.attr.eventOnFocus) {
          this.$emit('callBusinessRule', this.attr.eventOnFocus);
        }
      },
      callBusinessRuleBlur: function() {
        if (this.attr.eventOnBlur) {
          this.$emit('callBusinessRule', this.attr.eventOnBlur);
        }
      },
      classToDivBeforeInput: function () {
        if(this.attr.disableField) {
          return "el-input is-disabled";
        }
        return "el-input";
      }
    }
  }

</script>

<template>
  <div>
    <div class="el-form-item__content">
      <div :class="classToDivBeforeInput()">
        <input class="form-control el-input__inner"
               v-mask="mask"
               v-model="_value"
               :placeholder="placeholder"
               @focus="callBusinessRuleFocus"
               @blur="callBusinessRuleBlur"
               :disabled="attr.disableField"
        />
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// MaskedField.vue?7b9e09ee